import { render, staticRenderFns } from "./CommonDocumentGroup.vue?vue&type=template&id=187f09be"
import script from "./CommonDocumentGroup.vue?vue&type=script&lang=js"
export * from "./CommonDocumentGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports